export var getFirstLetter = function getFirstLetter(name) {
  return name.trim().substring(0, 1).toUpperCase();
};